/* =====================================================================
   FRANGIPANI — section reveal
   ---------------------------------------------------------------------
   The About page is a long read: a founder story, a pull quote, the
   brand, the commitments, the families, the questions. Stacked as flat
   blocks it arrives all at once and none of it lands. Each section now
   rises a few pixels and fades in as it comes into view, so the page
   reads as a sequence rather than a wall.

   Three rules this file follows, because a reveal that goes wrong hides
   the page:

     1. The hiding is done by CSS that only applies when this script has
        set data-fp-reveal="on" on <html>. No script, no hiding.
     2. That attribute is set synchronously, before first paint, so
        nothing flashes in and back out.
     3. prefers-reduced-motion, or a browser without IntersectionObserver,
        gets the page with no animation at all.

   To use it on another template, add its selector to TARGETS below and
   add the matching pair of rules in assets/fp-home.css.
   ===================================================================== */

(function () {
  var TARGETS =
    "main[data-template^='page.about'] > .shopify-section," +
    "main[data-template^='page.contact'] > .shopify-section";

  var root = document.documentElement;
  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced || !('IntersectionObserver' in window)) return;

  // Before paint, so the sections start hidden rather than blinking.
  root.setAttribute('data-fp-reveal', 'on');

  function reveal(el) {
    el.classList.add('fp-in');
  }

  function start() {
    var items = document.querySelectorAll(TARGETS);

    // Nothing to reveal on this template — take the hiding back off.
    if (!items.length) {
      root.removeAttribute('data-fp-reveal');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.04 }
    );

    items.forEach(function (el) {
      // Anything already on screen at load is shown immediately — the
      // hero should never animate in under the reader.
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) {
        reveal(el);
        return;
      }
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Footer link columns become accordions on phones; see fp-brand.css. */
(function () {
  function init() {
    var f = document.querySelector('footer');
    if (!f) return;
    f.querySelectorAll('[class*="__lbl"]').forEach(function (l) {
      var nxt = l.nextElementSibling;
      if (!nxt || !/__lnk/.test(nxt.className)) return;
      if (l.dataset.fpFacc) return;
      l.dataset.fpFacc = '1';
      l.classList.add('fp-facc');
      l.setAttribute('role', 'button');
      l.tabIndex = 0;
      l.setAttribute('aria-expanded', 'false');
      function mobile() { return window.matchMedia('(max-width: 749px)').matches; }
      function toggle() {
        var open = l.classList.toggle('fp-open');
        l.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      l.addEventListener('click', function () { if (mobile()) toggle(); });
      l.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && mobile()) { e.preventDefault(); toggle(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
